import {Factory} from './Factory'
import Menu from '../EditorComponents/HtmlCode/Menu'

export class HtmlCodeFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('html-code'),
      slug: 'editor-html-code',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: [],
      },
      containerClasses:{
        phone: [],
        tablet: [],
        desktop:[]
      },
      name: 'HtmlCode',
    }
  }

  properties() {
    return {
      content: [],
      styles: [
        {key: 'margin', component: 'MarginProperty'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}